// src/Component/Header.tsx
import React, { useState, useEffect } from 'react';
import { Menu, X, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/Front.png'; 

import logo2 from '../assets/Back.png'; 

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <>
      <motion.nav
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        // Header height h-20 fixed rakhi gayi hai
        className="fixed w-full z-50 bg-white h-20 shadow-md border-b border-gray-100 flex items-center"
      >
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 w-full flex items-center justify-between">
          
          {/* LEFT: Double Logo Section */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center gap-3 group">
              {/* Pehla Logo */}
              <div className="h-14 md:h-16 w-auto flex items-center">
                <img 
                  src={logo}   
                  alt="Primary Logo"
                  className="h-full w-auto object-contain scale-110 origin-left transition-transform duration-300 group-hover:scale-115"
                />
              </div>

              {/* Vertical Divider (Optional - Dono logo ke beech line) */}
              <div className="h-8 w-[1px] bg-gray-200 mx-1"></div>

              {/* Dusra Logo - Isme src={logo2} replace kar dena */}
              <div className="h-8 md:h-10 w-auto flex items-center">
                <img 
                  src={logo2} // Yahan logo2 variable daalein
                  alt="Secondary Logo"
                  className="h-full w-auto object-contain opacity-90 transition-all duration-300 group-hover:opacity-100"
                />
              </div>
            </Link>
          </div>

          {/* CENTER: Navigation Links (Absolute Center) */}
          <div className="hidden lg:flex absolute left-1/2 -translate-x-1/2 items-center gap-10">
            {navLinks.map((link) => (
              <Link 
                key={link.name}
                to={link.path} 
                className="relative text-[14px] tracking-[0.05em] font-bold text-gray-800 hover:text-red-600 transition-colors duration-300 group"
              >
                {link.name.toUpperCase()}
                <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-red-600 transition-all duration-300 group-hover:w-full rounded-full"></span>
              </Link>
            ))}
          </div>

          {/* RIGHT: High-Visibility Button */}
          <div className="flex items-center gap-4">
            <Link to="/demat/register" className="hidden md:block">
              <motion.button 
                whileHover={{ scale: 1.05, backgroundColor: "#dc2626" }}
                whileTap={{ scale: 0.95 }}
                className="bg-red-600 text-white px-9 py-2.5 rounded-full text-[15px] font-black uppercase tracking-wider shadow-lg shadow-red-100 transition-all"
              >
                Open Demat Account
              </motion.button>
            </Link>

            {/* Mobile Menu Toggle */}
            <button 
              className="lg:hidden text-gray-800 p-2 hover:bg-gray-100 rounded-lg" 
              onClick={() => setIsMobileMenuOpen(true)}
            >
              <Menu size={28} />
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] bg-white md:hidden flex flex-col"
          >
            <div className="flex justify-between items-center p-6 border-b">
              {/* Mobile Double Logo */}
              <div className="flex items-center gap-2 h-10">
                <img src={logo} alt="Logo 1" className="h-full object-contain" />
                <img src={logo2} alt="Logo 2" className="h-full object-contain opacity-70" />
              </div>
              <button onClick={() => setIsMobileMenuOpen(false)} className="text-red-600 p-2">
                <X size={30} />
              </button>
            </div>
            
            <div className="flex flex-col gap-2 p-6">
              {navLinks.map((link) => (
                <Link 
                  key={link.name}
                  to={link.path} 
                  className="p-4 text-xl font-bold text-gray-900 border-b border-gray-50 flex justify-between items-center"
                >
                  {link.name} <ChevronRight size={20} />
                </Link>
              ))}
            </div>

            <div className="mt-auto p-6">
              <Link to="/demat/register">
                <button className="w-full py-4 bg-red-600 text-white font-bold rounded-xl shadow-lg uppercase">
                  Open Demat Account
                </button>
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;